export default "__VITE_ASSET__CTBf86Ta__"